<template>
  <div>
    <div class="signup">
      <Sidebar />
      <Form :signup="false" msg="Sign In" @formSubmitted="signinUser($event)" />
    </div>
  </div>
</template>

<script>
import Sidebar from "@/components/accounts/sidebar";
import Form from "@/components/accounts/form";
export default {
  name: "signin",
  components: {
    Sidebar,
    Form
  },
  methods: {
    signinUser(data) {
      console.log(data);
    }
  }
};
</script>

<style lang="scss" scoped>
.signup {
  min-height: 100vh;
}
</style>
